// Chart colours, validated rather than picked by eye.
//
// Each hex below passes the OKLCH lightness band for its mode, the chroma
// floor, and >=3:1 contrast against the card surface it is drawn on
// (#ffffff light, #0c2b31 dark). The categorical order is fixed: slot 1 is
// always the first series, slot 2 always the second, so filtering a series
// out never repaints the ones that remain.
export const CHART = {
  light: {
    // Single-series marks and the primary line.
    mark: '#3a8f66',
    // Fixed categorical order for the donut and multi-series charts.
    categorical: ['#3a8f66', '#2a6f9e', '#c2762a', '#8a5cc4', '#b2444c'],
    grid: 'rgba(19, 42, 33, 0.10)',
    axis: '#7c8f85',
    muted: '#dfe8e3',
    surface: '#ffffff',
  },
  dark: {
    mark: '#3fa877',
    categorical: ['#3fa877', '#3f92c7', '#c08339', '#9a74d1', '#c85f68'],
    grid: 'rgba(232, 242, 236, 0.10)',
    axis: '#7e988c',
    muted: '#1e4034',
    surface: '#0c2b31',
  },
};

export const chartColors = (theme) => (theme === 'dark' ? CHART.dark : CHART.light);

export const formatMinutes = (m) => {
  const value = Math.round(m || 0);
  if (!value) return '0m';
  if (value < 60) return `${value}m`;
  const h = Math.floor(value / 60);
  const rem = value % 60;
  return rem ? `${h}h ${rem}m` : `${h}h`;
};

export const formatCompact = (n) => {
  const value = Number(n) || 0;
  if (value >= 1000000) return `${(value / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  if (value >= 1000) return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  return String(value);
};

// Only the ends and the peak get an axis tick, so a 30-bar chart does not
// turn its x-axis into a grey smear.
export const sparseTicks = (data, index, key = 'value') => {
  if (!data.length) return '';
  let peak = 0;
  data.forEach((d, i) => { if ((d[key] || 0) > (data[peak][key] || 0)) peak = i; });
  const showPeak = (data[peak]?.[key] || 0) > 0;
  if (index === 0 || index === data.length - 1 || (showPeak && index === peak)) {
    return data[index]?.label ?? '';
  }
  return '';
};
